module.exports = __webpack_public_path__ + "images/emoji/abcd.ea45f2ed35eab366bcb6.png";